module.exports = {"131126100":"郑口镇","131126101":"夏庄镇","131126102":"青罕镇","131126103":"故城镇","131126104":"武官寨镇","131126105":"饶阳店镇","131126106":"军屯镇","131126107":"建国镇","131126108":"西半屯镇","131126109":"房庄镇","131126110":"三朗镇","131126200":"辛庄乡","131126201":"里老乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131126.json
// module id = 337
// module chunks = 0